import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import Analysis from "./pages/Analysis";
import Plan from "./pages/Plan";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Share from "./pages/Share";
import Progress from "./pages/Progress";
import CoachDashboard from "./pages/CoachDashboard";
import CoachAthlete from "./pages/CoachAthlete";
import Invite from "./pages/Invite";
import Compare from "./pages/Compare";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-neutral-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/upload" element={<Protected><Upload /></Protected>} />
            <Route path="/analysis/:id" element={<Protected><Analysis /></Protected>} />
            <Route path="/plan" element={<Protected><Plan /></Protected>} />
            <Route path="/progress" element={<Protected><Progress /></Protected>} />
            <Route path="/coach" element={<Protected><CoachDashboard /></Protected>} />
            <Route path="/coach/athletes/:athleteId" element={<Protected><CoachAthlete /></Protected>} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/share/:token" element={<Share />} />
            <Route path="/invite/:token" element={<Invite />} />
            <Route path="/compare" element={<Protected><Compare /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
